// utils/exportExcelStyled.ts
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";

export const exportToExcel = ({ data, fileName = "data.xlsx", headers }) => {
    const headerRow = headers.map((h) => ({
        v: h.label,
        s: {
            font: { bold: true },
            fill: { fgColor: { rgb: "DCE6F1" } },
            alignment: { horizontal: "center" },
        },
    }));

    const bodyRows = data.map((row) => {
        const highlightRow = row["exists_name"] === "重複";
        const rowStyle = highlightRow
            ? {
                fill: { fgColor: { rgb: "FFC7CE" } }, // 淺紅底
                font: { color: { rgb: "9C0006" } },   // 深紅字
            }
            : {};

        return headers.map((h) => ({
            v: row[h.key],
            s: rowStyle,
        }));
    });

    const worksheetData = [headerRow, ...bodyRows];

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, fileName);
};


